import React, { useEffect, useState } from "react";
import "./contentProvider.css";
import {
  GetContentProviderCount,
  GetContentProviderData,
  UnblockCp,
} from "../../../../api/Api";
import CustomModal from "../../../../components/Modal/CustomModal";
import CreateCp from "./createCp/CreateCp";
import EditCp from "./editCp/EditCp";
import ViewCp from "./viewCp/ViewCp";
import Swal from "sweetalert2";
import PaginationComponent from "../../../../components/Pagination/PaginationComponent";
import CustomTable from "../../../../components/Table/CustomTable";
import { getFromLocalStorage } from "../../../../utils/common-utils";
import BlockCp from "./blockCp/BlockCp";
import { Navigate } from "react-router-dom";

const ContentProvider = () => {
  const [currentPage, setCurrentPage] = useState(0);
  const [enabledColumns, setEnabledColumns] = useState([]);
  const [totalPages, setTotalPages] = useState(null);
  const [pageSize, setPageSize] = useState(10);
  const [pageSizeArr] = useState([10, 20, 30, 40, 50]);
  const [tableData, setTableData] = useState(null);
  const [tabs, setTabs] = useState([]);
  const [tabVal, setTabVal] = useState(1);
  const [createCpModal, setCreateCpModal] = useState(false);
  const [stateData, setStateData] = useState({
    tableLoader: true,
    countLoader: true,
    filterClick: true,
    nameFilterChecked: false,
    dateTimeFilterChecked: false,
    updatedByFilterChecked: false,
  });
  const [editCpModal, setEditCpModal] = useState(false);
  const [viewCpModal, setViewCpModal] = useState(false);
  const [blockCpModal, setBlockCpModal] = useState(false);
  const [totalElements, setTotalElements] = useState(0);
  const [approveCpModal, setApproveCpModal] = useState(false);
  const [rejectCpModal, setRejectCpModal] = useState(false);
  const [rowData, setRowData] = useState(null);
  const [messageDescription, setMessageDescription] = useState("");


  const getAllData = async () => {
    setStateData((prev) => ({ ...prev, tableLoader: true }));
    let payload = {
      pageNo: currentPage,
      pageSize: pageSize,
      userId: getFromLocalStorage("userData")?.id,
      status: tabVal,
    };
    const response = await GetContentProviderData(payload);
    console.log("resFetchBU", response);
    setStateData((prev) => ({ ...prev, tableLoader: false }));
    if (response?.statusDescription?.status == 200) {
      const contentWithActions = response?.userListPage?.content?.map(
        (item) => ({
          ...item,
          actions: response?.action,
        })
      );
      setTotalPages(response?.userListPage?.page?.totalPages);
      setTotalElements(response?.userListPage?.page?.totalElements);
      setTableData(contentWithActions);
        setEnabledColumns(response?.enabledColumns);
    } 
  //   else if (response?.status == 401) {
  //     handleUnauthorized();  
  // }
   else {
      setTableData([]);
      setTotalPages(null);
      setMessageDescription(response?.statusDescription?.description || "Failed to fetch data");
      setEnabledColumns([]);
    }
  };


  // const handleUnauthorized = () => {
  //   alert("Session expired, please login again");
  //   Swal.fire("info!", "Session expired, please login again", "info");
  //   localStorage.clear();
  //   Navigate("/");
  // };

  const handlePageChange = (pageNumber) => {
    setCurrentPage(pageNumber);
  };

  const handleAction = (action, rowData, newStatus) => {
    console.log("rowData", rowData, action);
    setRowData(rowData);
    if (action.id == 118) {
      setViewCpModal(true);
    } else if (action?.id == 119) {
      setEditCpModal(true);
    } else if (action?.id == 120) {
      setBlockCpModal(true);
    } else if (action?.id == 121) {
      Swal.fire({
        title: "Unblock Content Provider",
        text: "Are you sure you want to unblock this content provider?",
        icon: "warning",
        showCancelButton: true,
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33",
        confirmButtonText: "Yes, unblock it!",
        cancelButtonText: "No",
        showLoaderOnConfirm: true,
        preConfirm: async () => {
          try {
            let payload = {
              userId: getFromLocalStorage("userData")?.id,
              blockedUserId: rowData?.id,
              blockedMessage: null,
            };
            const response = await UnblockCp(payload);
            if (response?.statusDescription?.status === 200) {
              return response;
            } else {
              return Swal.showValidationMessage(
                response?.statusDescription?.description ||
                "Failed to unblock content provider"
              );
            }
          } catch (error) {
            return Swal.showValidationMessage(
              "Something went wrong. Please try again."
            );
          }
        },
        allowOutsideClick: () => !Swal.isLoading(),
      }).then((result) => {
        if (result.isConfirmed) {
          Swal.fire(
            "Success!",
            result.value?.statusDescription?.description,
            "success"
          );
          getAllData();
          getCount();
        }
      });
    }
  };

  // approve cp
  // const handleApproveCpSubmit = (e) => {
  //   e.preventDefault();
  //   alert("Approved successfully");
  //   setApproveCpModal(false);
  // };

  // reject cp
  // const handleRejectCpSubmit = (e) => {
  //   e.preventDefault();
  //   alert("Rejected successfully");
  //   setRejectCpModal(false);
  // };

  const getCount = async () => {
    setStateData((prev) => ({ ...prev, countLoader: true }));
    const response = await GetContentProviderCount();
    setStateData((prev) => ({ ...prev, countLoader: false }));
    console.log("responseCount", response);
    if (response?.statusDescription?.status === 200) {
      setTabs(response?.userCountResponeList);
    } else {
      setTabs([]);
      // Swal.fire(response?.statusDescription?.description, "info");
    }
  };

  useEffect(() => {
    getCount();
  }, []);

  useEffect(() => {
    getAllData();
  }, [currentPage, pageSize, tabVal]);

  return (
    <div class="content-wrapper">
      <section class="content">
        <div class="row">
          <div class="col-md-12 twelve_div">
            <div class="box">
              <div class="box-header">
                <div class="row">
                  <div class="col-md-8 col-12">
                    <nav aria-label="breadcrumb">
                      <ol class="breadcrumb breadcrumb_bg">
                        <li class="breadcrumb-item">
                          <a class="breadcrumb_1">Manage Content Provider</a>
                        </li>
                        <li
                          class="breadcrumb-item active breadcrumb_2 d-flex align-items-center"
                          aria-current="page"
                        >
                         <span>Content Provider</span> 
                        </li>
                      </ol>
                    </nav>
                  </div>
                  <div class="col-md-4 col-12 mt_3 d-flex align-items-center justify-content-end">
                    <div class="btn-group float-right">
                      {/* <button
                        type="button"
                        name="enable"
                        className="btn btn-primary btn-raised btn-flat no-margin margin_right_10 btn_pad"
                        title="View Cp Detail"
                        onClick={() => {
                          setViewCpModal(true);
                        }}
                      >
                        <i className="fa fa-eye"></i>
                      </button> */}
                      {/* <button
                        type="button"
                        name="enable"
                        className="btn btn-secondary btn-raised btn-flat no-margin btn_pad"
                        title="Edit Cp Detail"
                        onClick={() => {
                          setEditCpModal(true);
                        }}
                      >
                        <i className="fa fa-pencil"></i>
                      </button>
                      <button
                        type="button"
                        name="enable"
                        className="btn btn-danger btn-raised btn-flat no-margin btn_pad ml-2"
                        title="Deactivate Cp"
                        onClick={() => {
                          setBlockCpModal(true);
                        }}
                      >
                        <i className="fa fa-ban"></i>
                      </button> */}
                      {/* <button
                        type="button"
                        name="enable"
                        className="btn btn-success btn-raised btn-flat no-margin btn_pad ml-2"
                        title="Approve Cp"
                        onClick={() => {
                          setApproveCpModal(true);
                        }}
                      >
                        <i className="fa fa-check"></i>
                      </button>
                      <button
                        type="button"
                        name="enable"
                        className="btn btn-warning btn-raised btn-flat no-margin btn_pad ml-2"
                        title="Reject Cp"
                        onClick={() => {
                          setRejectCpModal(true);
                        }}
                      >
                        <i className="fa fa-times"></i>
                      </button> */}
                      <button
                        type="button"
                        class="btn btn-primary btn-raised btn-flat create_cp"
                        onClick={() => setCreateCpModal(true)}
                      >
                        Create CP
                      </button>
                    </div>
                  </div>
                </div>
              </div>

              <div class="box-body">
                <ul class="nav nav-tabs" id="myTab" role="tablist">
                  {tabs &&
                    tabs.map((item) => (
                      <li
                        class="nav-item position-relative"
                        role="presentation"
                      >
                        <a
                          class={`nav-link ${item?.tabStatus == tabVal ? "active" : ""
                            } approved_cp`}
                          id="home-tab"
                          data-toggle="tab"
                          href={`#${item?.tabStatus}`}
                          role="tab"
                          aria-controls="home"
                          aria-selected="true"
                          onClick={() => setTabVal(item?.tabStatus)}
                        >
                          {item?.tabName}
                        </a>
                        <span
                          class={`badge badge-pill ${item?.colorCode} rounded-circle count`}
                        >
                          {item?.defaultCount}
                        </span>
                      </li>
                    ))}
                </ul>
                <div class="tab-content" id="myTabContent">
                  <div
                    class="tab-pane fade show active pt-2"
                    id="home"
                    role="tabpanel"
                    aria-labelledby="home-tab"
                  >
                    {stateData?.tableLoader ? (
                      <div className="container">
                        <div className="row g-3">
                          <div className="col-12">
                            <div className="placeholder-glow">
                              <div
                                className="placeholder col-12 rounded"
                                style={{ height: "40px" }}
                              ></div>
                            </div>
                          </div>
                          {[...Array(5)].map((_, index) => (
                            <div className="col-12" key={index}>
                              <div className="placeholder-glow">
                                <div
                                  className="placeholder col-12 rounded"
                                  style={{ height: "50px" }}
                                ></div>
                              </div>
                            </div>
                          ))}
                        </div>
                      </div>
                    ) : !stateData?.tableLoader && tableData?.length > 0 ? (
                      <>
                        <div className="form-group d-flex align-items-center justify-content-between gap-2 records">
                          <div className="d-flex">
                            <span>Show</span>
                            <select
                              className="form-select count_select mx-2"
                              value={pageSize}
                              onChange={(e) => {
                                setPageSize(Number(e.target.value));
                                setCurrentPage(0);
                              }}
                            >
                              {pageSizeArr?.map((size) => (
                                <option key={size} value={size}>
                                  {size}
                                </option>
                              ))}
                            </select>
                            <span>entries</span>
                          </div>
                          <div>
                            <button type="button" className="btn btn-primary ref_but" onClick={() => getAllData()}>Refresh &nbsp;<i
                              class="fas fa-sync ms-auto"
                              style={{ cursor: "pointer" }}
                              title="Refresh"
                              
                            ></i></button>
                          </div>
                        </div>

                        <div id="table">
                          <CustomTable
                            data={tableData}
                            enabledColumns={enabledColumns}
                            onAction={handleAction}
                            currentPage={currentPage}
                            pageSize={pageSize}
                          />
                        </div>

                        <div
                          className="d-flex justify-content-between align-items-center flex-column flex-md-row w-100"
                          id="pagination"
                        >
                          <div className="mr-3 line_pagination px-2 px-md-0">
                            Showing {currentPage * pageSize + 1} to{" "}
                            {Math.min(
                              (currentPage + 1) * pageSize,
                              tableData.length + currentPage * pageSize
                            )}{" "}
                            of {totalElements} entries
                          </div>
                          <div className="pages">
                            <PaginationComponent
                              currentPage={currentPage}
                              onPageChange={handlePageChange}
                              totalPages={totalPages}
                            />
                          </div>
                        </div>
                      </>
                    ) : !stateData?.tableLoader && tableData?.length == 0 ? (
                      <div className="d-flex justify-content-center">
                        <h4>{messageDescription}</h4>
                      </div>
                    ) : (
                      ""
                    )}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* create cp modal */}
      <CustomModal
        show={createCpModal}
        onHide={() => {
          setCreateCpModal(false);
        }}
        title="Create Content Provider"
        size="xl"
        dialogClassName="custom-modal-class"
      >
        <div style={{ maxHeight: "70vh", overflowY: "auto", overflowX: "hidden" }}>
          <CreateCp
            setCreateCpModal={setCreateCpModal}
            getAllData={getAllData}
            getCount={getCount}
          />
        </div>
      </CustomModal>

      {/* edit cp modal */}
      <CustomModal
        show={editCpModal}
        onHide={() => {
          setEditCpModal(false);
        }}
        title="Edit Content Provider Details"
        size="xl"
        dialogClassName="custom-modal-class"
      >
        <div style={{ maxHeight: "70vh", overflowY: "auto", overflowX: "hidden" }}>
        <EditCp
          setEditCpModal={setEditCpModal}
          editData={rowData}
          getAllData={getAllData}
          getCount={getCount}
        />
        </div>
      </CustomModal>

      {/* view cp modal */}
      <CustomModal
        show={viewCpModal}
        onHide={() => {
          setViewCpModal(false);
        }}
        title="View Content Provider Details"
        size="xl"
        dialogClassName="custom-modal-class"
      >
        <div style={{ maxHeight: "70vh", overflowY: "auto", overflowX: "hidden" }}>
          <ViewCp viewData={rowData} />
        </div>
      </CustomModal>

      {/* block cp modal */}
      <CustomModal
        show={blockCpModal}
        onHide={() => {
          setBlockCpModal(false);
        }}
        title="Block CP"
        size="md"
        dialogClassName="custom-modal-class"
      >
        <BlockCp
          setBlockCpModal={setBlockCpModal}
          rowData={rowData}
          getAllData={getAllData}
          getCount={getCount}
        />
      </CustomModal>

      {/* approve cp modal */}
      {/* <CustomModal
        show={approveCpModal}
        onHide={() => {
          setApproveCpModal(false);
        }}
        title="Approve Content Provider"
        size="md"
        dialogClassName="custom-modal-class"
      >
        <form onSubmit={handleApproveCpSubmit}>
          <p>Are you sure you want to approve this CP.</p>
          <div class="modal-footer border-0 justify_center">
            <button
              type="button"
              class="btn btn-danger"
              aria-label="Close"
              onClick={() => {
                setApproveCpModal(false);
              }}
            >
              Cancel
            </button>
            <button type="submit" class="btn btn-primary">
              Confirm
            </button>
          </div>
        </form>
      </CustomModal> */}

      {/* reject cp modal */}
      {/* <CustomModal
        show={rejectCpModal}
        onHide={() => {
          setRejectCpModal(false);
        }}
        title="Reject Content Provider"
        size="md"
        dialogClassName="custom-modal-class"
      >
        <form onSubmit={handleRejectCpSubmit}>
          <p>Are you sure you want to reject this CP.</p>
          <div class="modal-footer border-0 justify_center">
            <button
              type="button"
              class="btn btn-danger"
              aria-label="Close"
              onClick={() => {
                setRejectCpModal(false);
              }}
            >
              Cancel
            </button>
            <button type="submit" class="btn btn-primary">
              Confirm
            </button>
          </div>
        </form>
      </CustomModal> */}
    </div>
  );
};

export default ContentProvider;
